"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;




















































































var _user = require("@/utils/user");


var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { list: null, tableData: [], // 列表数据
      searchData: { userName: '', mobile: '', markSource: '', time: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pickerOptions: { disabledDate: function disabledDate(time) {return time.getTime() > Date.now();} }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { remark: '' }, // 表格列
      tableColumns: [{ prop: 'userName', label: '用户名', isShow: true // 是否显示
      }, { prop: 'mobile', label: '手机号', isShow: true // 是否显示
      }, { prop: 'markSource', label: '用户来源', isShow: true // 是否显示
      }, { prop: 'createTime', label: '注册时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }, { prop: 'sex', label: '性别', formatter: _formatter.userSexFormatter, isShow: true // 是否显示
      }, { prop: 'country', label: '国籍', isShow: true // 是否显示
      }, { prop: 'province', label: '省份', isShow: true // 是否显示
      }, { prop: 'city', label: '城市', isShow: true // 是否显示
      }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { // 获取数据
    init: function init() {var self = this;var params = Object.assign({}, self.searchData);if (params.time) {params.startTime = params.time[0] + ' 00:00:00';params.endTime = params.time[1] + ' 23:59:59';}delete params['time'];self.getData('/api/faProgramMark/summary', params, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, // 每页多少条数据
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    // 当前页
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.init();
    },
    resetFun: function resetFun() {
      // 重置
      this.searchData.userName = '';
      this.searchData.mobile = '';
      this.searchData.markSource = '';
      this.searchData.time = '';
      this.init();
    },
    searchFun: function searchFun() {
      // 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    remarkFun: function remarkFun(item) {
      var self = this;
      self.addData.remark = item.remark;
      self.putData('/api/faProgramMark/updateUserRemark', {
        userId: item.userId,
        remarks: item.remarks },
      function (res) {
        self.$message({
          message: '修改成功!',
          type: 'success' });

        self.init();
      });
    } } };exports.default = _default;